var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 5.8335H14.9997C15.5468 5.8335 16.0887 5.94127 16.5942 6.15066C17.0997 6.36006 17.559 6.66697 17.946 7.05388C18.3329 7.4408 18.6398 7.90013 18.8492 8.40565C19.0586 8.91117 19.1663 9.45299 19.1663 10.0002C19.1663 10.5473 19.0586 11.0892 18.8492 11.5947C18.6398 12.1002 18.3329 12.5595 17.946 12.9464C17.559 13.3334 17.0997 13.6403 16.5942 13.8497C16.0887 14.0591 15.5468 14.1668 14.9997 14.1668H12.4997M7.49967 14.1668H4.99967C4.4525 14.1668 3.91068 14.0591 3.40516 13.8497C2.89964 13.6403 2.44031 13.3334 2.0534 12.9464C1.27199 12.165 0.833008 11.1052 0.833008 10.0002C0.833008 8.89509 1.27199 7.83529 2.0534 7.05388C2.8348 6.27248 3.89461 5.8335 4.99967 5.8335H7.49967",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10H13.3337",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconShare);
export default __webpack_public_path__ + "static/media/link-icon-share.16f6d7a1eedb8e9956426ce8c780ddaa.svg";
export { ForwardRef as ReactComponent };